import { useAppDispatch, useAppSelector } from 'app/hooks';
import { editModeActions, selectEditModeData, selectIsEditMode } from 'features/common/editModeSlice';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import barrierIcon from './images/icon.png';
import './style.scss';

function EditModeHeader() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);
  const deliveryId = useAppSelector(selectEditModeData)?.deliveryId;

  function handleReturnNormalMode() {
    dispatch(editModeActions.disableEditMode());
    history.push('/delivery/delivery-setting');
  }

  return isEditMode ? (
    <div className="reedit-banner">
      <div className="text-align-center">
        <p className="m-auto">
          <img width={20} height={20} src={barrierIcon} alt="Barrier Icon" />
          {t('EditModeHeader.text1', { deliveryId })}
          <br />
          {t('EditModeHeader.text2')}
        </p>
      </div>

      <button className="reedit-banner-button" onClick={handleReturnNormalMode}>
        {t('EditModeHeader.button')}
      </button>
    </div>
  ) : null;
}

export default EditModeHeader;
